import { createClient } from '@supabase/supabase-js';

// Tolère une URL copiée avec /rest/v1/ ou une barre finale
const url = (import.meta.env.VITE_SUPABASE_URL as string | undefined)?.trim().replace(/\/(rest|auth)\/v1\/?$/, '').replace(/\/+$/, '') as string;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY as string;
if (!url || !anon) throw new Error('VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY manquants (.env.local)');

/** Seule la clé anon est exposée au navigateur : toute la sécurité repose sur la RLS. */
export const supabase = createClient(url, anon, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});

export const FUNCTIONS_URL = `${url}/functions/v1`;
